import React from 'react';

import { PieSvgProps, ResponsivePie } from '@nivo/pie';

interface IProps extends Omit<PieSvgProps<any>, 'width' | 'height'> {
	data: any[];
}
const ChartPie = (props: IProps) => (
	<ResponsivePie
		valueFormat={(value) => `${value}%`}
		margin={{ top: 5, right: 10, bottom: 10, left: 10 }}
		innerRadius={0.5}
		padAngle={0.7}
		cornerRadius={3}
		activeOuterRadiusOffset={8}
		borderWidth={1}
		borderColor={{
			from: 'color',
			modifiers: [['darker', 0.2]],
		}}
		arcLinkLabelsSkipAngle={10}
		arcLinkLabelsTextColor="#333333"
		arcLinkLabelsThickness={2}
		arcLinkLabelsColor={{ from: 'color' }}
		arcLabelsSkipAngle={10}
		arcLabelsTextColor={{
			from: 'color',
			modifiers: [['darker', 2]],
		}}
		enableArcLabels={false}
		enableArcLinkLabels={false}
		colors={{ datum: 'data.color' }}
		{...props}
	/>
);

export default ChartPie;
